var _g, _g2, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoParticipationIllustration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 117,
    viewBox: "0 0 151 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5202_12534)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_5202_12534)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.29321,
    y: 25.252,
    width: 95.687,
    height: 84.8912,
    rx: 6.93,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.29321,
    y: 25.252,
    width: 95.687,
    height: 84.8912,
    rx: 6.93,
    fill: "#CBDBFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.3401,
    y: 15.8594,
    width: 95.687,
    height: 84.8912,
    rx: 6.93,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.3401,
    y: 15.8594,
    width: 95.687,
    height: 84.8912,
    rx: 6.93,
    fill: "url(#paint0_linear_5202_12534)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3401 22.7894C12.3401 18.962 15.4428 15.8594 19.2701 15.8594H101.097C104.924 15.8594 108.027 18.962 108.027 22.7894V37.8621H12.3401V22.7894Z",
    fill: "#9EBCFF"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 34.2236,
    cy: 80.697,
    r: 5.445,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.9535,
    cy: 56.9372,
    r: 5.445,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.9535,
    cy: 80.697,
    r: 5.445,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 87.6835,
    cy: 56.9372,
    r: 5.445,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 87.6835,
    cy: 80.697,
    r: 5.445,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.2507,
    y: 7.4375,
    width: 9.9,
    height: 16.8513,
    rx: 1.98,
    fill: "#FAFDFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.2168,
    y: 7.4375,
    width: 9.9,
    height: 16.8513,
    rx: 1.98,
    fill: "#FAFDFF"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: 97.34,
    y: -0.388047,
    width: 52.8,
    height: 54.1195
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.32px)",
      clipPath: "url(#bgblur_0_5202_12534_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_5202_12534)",
    "data-figma-bg-blur-radius": 2.64
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 123.74,
    cy: 26.012,
    r: 23.76,
    fill: "url(#paint1_linear_5202_12534)",
    fillOpacity: 0.71,
    shapeRendering: "crispEdges"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M131.106 14.9074C132.139 13.8749 133.813 13.8749 134.846 14.9074C135.878 15.9401 135.878 17.6149 134.846 18.6476L127.48 26.0128L134.846 33.3781C135.878 34.4108 135.878 36.0856 134.846 37.1183C133.813 38.151 132.138 38.151 131.105 37.1183L123.74 29.7531L116.375 37.1183C115.342 38.151 113.667 38.151 112.635 37.1183C111.602 36.0856 111.602 34.4107 112.635 33.3781L120 26.0128L112.635 18.6476C111.602 17.6149 111.602 15.9401 112.635 14.9074C113.667 13.8746 115.342 13.8746 116.375 14.9074L123.74 22.2726L131.106 14.9074Z",
    fill: "#4C95FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5202_12534",
    x: 0.333213,
    y: 5.4575,
    width: 111.654,
    height: 110.625,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.98
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.98
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.372549 0 0 0 0 0.52549 0 0 0 0 0.74902 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5202_12534"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5202_12534",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_5202_12534",
    x: 97.34,
    y: -0.388047,
    width: 52.8,
    height: 54.1195,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.32
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.32
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.372549 0 0 0 0 0.52549 0 0 0 0 0.74902 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5202_12534"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5202_12534",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_5202_12534_clip_path",
    transform: "translate(-97.34 0.388047)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 123.74,
    cy: 26.012,
    r: 23.76
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5202_12534",
    x1: 60.1836,
    y1: 15.8594,
    x2: 60.1836,
    y2: 128.605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDEBF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9E2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5202_12534",
    x1: 99.98,
    y1: 22.052,
    x2: 150.47,
    y2: 37.562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFBF4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoParticipationIllustration);
export default __webpack_public_path__ + "static/media/noParticipationIllustration.890422a59fa3f0f6f721764b14c35076.svg";
export { ForwardRef as ReactComponent };